'use client';

import { isDesktop } from 'react-device-detect';

import {
  HEADER_HEIGHT,
  SCROLL_RETRY_GAP,
  SCROLL_RETRY_MAX,
  SELECTOR,
} from './constants';

/**
 * 요청한 스크롤이 실제로 움직였는지 주기적으로 확인한다.
 * 멈춰 있으면 다시 요청하고, 재시도를 다 쓰면 모션 없이 바로 이동한다.
 * 사용자가 손을 대거나 기준 요소가 사라지면 중단한다.
 */
const watchArrival = ($seat: Element, targetTop: number): void => {
  let tries = 0;
  let last = window.pageYOffset;
  let timer = 0;

  const give = () => {
    window.clearTimeout(timer);
    window.removeEventListener('touchstart', give);
    window.removeEventListener('wheel', give);
  };

  const check = () => {
    // 기준 요소가 사라졌으면(페이지 이동 등) 중단한다
    if (!$seat.isConnected) {
      give();
      return;
    }

    const now = window.pageYOffset;
    const moving = Math.abs(now - last) > 1;
    last = now;

    if (now <= targetTop + 1) {
      give();
      return;
    }

    // 멈췄는데 목표에 못 왔으면 다시 요청한다
    if (!moving) {
      tries += 1;
      if (tries > SCROLL_RETRY_MAX) {
        window.scrollTo({ top: targetTop });
        give();
        return;
      }
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    }

    timer = window.setTimeout(check, SCROLL_RETRY_GAP);
  };

  window.addEventListener('touchstart', give, { passive: true });
  window.addEventListener('wheel', give, { passive: true });
  timer = window.setTimeout(check, SCROLL_RETRY_GAP);
};

/**
 * LP 최상단으로 이동한다.
 * 카테고리 탭이 헤더에 붙는 지점까지 부드럽게 올리고, 이미 그보다 위면 움직이지 않는다.
 *
 * @returns 이동했으면 목표 위치, 아니면 null
 */
export const scrollToListTop = (): number | null => {
  const $seat = document.querySelector(`${SELECTOR.wrap} ${SELECTOR.seat}`);
  if (!$seat) return null;

  // 모바일은 헤더가 고정이라 그 높이만큼 덜 올린다
  const headerHeight = isDesktop ? 0 : HEADER_HEIGHT;
  // 소수점은 올림해 탭이 헤더에 딱 붙는 위치로 만든다
  const targetTop = Math.ceil(
    $seat.getBoundingClientRect().top + window.pageYOffset - headerHeight
  );

  if (window.pageYOffset <= targetTop) return null;

  window.scrollTo({ top: targetTop, behavior: 'smooth' });
  watchArrival($seat, targetTop);

  return targetTop;
};
